var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg7E0A5F402(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.904,
    height: 69.08,
    viewBox: "0 0 48.904 69.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2788",
    "data-name": "Group 2788",
    transform: "translate(-20.547 -10.46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M64.107,10.46H25.893a5.352,5.352,0,0,0-5.346,5.346V74.194a5.352,5.352,0,0,0,5.346,5.346H64.107a5.352,5.352,0,0,0,5.345-5.346V15.806A5.351,5.351,0,0,0,64.107,10.46Zm2.056,63.735a2.059,2.059,0,0,1-2.056,2.057H25.893a2.059,2.059,0,0,1-2.057-2.057V15.806a2.059,2.059,0,0,1,2.057-2.057H64.107a2.059,2.059,0,0,1,2.056,2.057Z",
    fill: "#efab00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M61.66,17.5H28.341A1.645,1.645,0,0,0,26.7,19.145V66.608a1.645,1.645,0,0,0,1.645,1.645h33.32a1.645,1.645,0,0,0,1.645-1.645V19.145A1.646,1.646,0,0,0,61.66,17.5ZM60.015,64.964H29.985V20.79h30.03V64.964Z",
    fill: "#efab00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M45,70.011a2.019,2.019,0,1,0,2.019,2.019A2.022,2.022,0,0,0,45,70.011Z",
    fill: "#efab00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M35.942,40.728h4.582a.352.352,0,0,0,.352-.352V36.494h4.31v3.882a.352.352,0,0,0,.352.352h4.075v4.309H45.539a.352.352,0,0,0-.352.352v3.877H40.877V45.382a.352.352,0,0,0-.352-.352H35.943a.352.352,0,0,0-.352.352v7.765a.352.352,0,0,0,.352.352h7.842a10.625,10.625,0,0,0,.34-21.245H35.942a.352.352,0,0,0-.352.352v7.768A.352.352,0,0,0,35.942,40.728Z",
    fill: "#efab00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg7E0A5F402);
export default __webpack_public_path__ + "static/media/7.e0a5f402.1ad7ef3ff42629684a7aadb07eb4d4ce.svg";
export { ForwardRef as ReactComponent };